import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header_right" }
const _hoisted_3 = ["onClick"]

import { ref,reactive } from "vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'header',
  props: {
  idx: Number
},
  setup(__props) {

const router = useRouter();
const props = __props;


let arr : any[] = reactive([{
    name: "首页",
    key: 1,
    router: "home"
},{
    name: "关于我们",
    key: 2,
    router: "aboutUs"
}, {
  name: "联系我们",
  key: 3,
  router: "contactUs"
}])
function goRouter(item: object){
  router.push({
      name: item?.router
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "logo"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(arr), (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass({'select': props.idx == item.key}),
            onClick: ($event: any) => (goRouter(item))
          }, _toDisplayString(item.name), 11, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}
}

})